module.exports = __webpack_public_path__ + "img/position_title_bag.2caaac77.png";